export interface WindowSizeDataState {
    width: number,
    height: number,
    isMobile: boolean
}

export const UPDATE_WINDOW_SIZE = "UPDATE_WINDOW_SIZE";

interface UpdateWindowSizeAction {
    type: typeof UPDATE_WINDOW_SIZE,
    payload: WindowSizeDataState,
}

export type WindowSizeActionTypes = UpdateWindowSizeAction